<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="isCreate ? newRules: updateRules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>

            <!-- <div class="flex">
              <base-ro-input-minimal :label="$t('rules.enuso_extend')"/>
            </div> -->

            <div class="lg:mb-2" v-if="(role === 7 || role === 8 || role === 3)">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.entity_name')}}</label>
              <div class="flex justify-between">
                <el-form-item prop="clienteId" class="w-full">
                  <el-select class="w-full" filterable v-model="form.clienteId" :disabled="!isCreate">
                    <el-option
                      v-for="cliente in clientes"
                      :key="cliente.idCliente"
                      :label="cliente.Nombre"
                      :value="cliente.idCliente">
                    </el-option>
                  </el-select>
                </el-form-item>
                <base-button v-if="!isCreate" class="mt-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.name')}}</label>
                <el-form-item prop="name">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.name"
                    maxlength='100'
                  />
                </el-form-item>
              </div>
            </div>
            
            <div class="lg:mb-2">
              <div class="mandatory">
                <div class="flex items-center mb-1">
                  <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('configurations.prioridad')}}</label>
                  <base-tooltip-icon size="sm" :content="tooltipPrioridad" class="ml-2"/>
                </div>
                <el-form-item prop="prioridad">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.prioridad"
                    maxlength='5'
                  />
                </el-form-item>
              </div>
            </div>

            <div class="mb-6">
              <label class="text-sm font-semibold text-secondary-600 block mb-2">{{$t('rules.tipo_app')}}</label>
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="">
                  <div class="flex flex-row items-center mb-4 lg:mb-0">
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.EnEmision" 
                      :active-text="$t('invoices.issued_header')"
                      :inactive-text="$t('invoices.received_header')"
                      inactive-color="var(--primary-800)">
                    </el-switch>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!form.EnEmision">
              <div class="lg:mb-4">
                <div class="flex flex-row items-center">
                  <el-switch class="switch-text break-normal" v-model="linkWorkflow" :active-text="$t('approval_workflow.link')"></el-switch>
                </div>
              </div>
              <div v-if="linkWorkflow" class="lg:mb-4">
                <div class="flex items-center mb-1">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{ $t('approval_workflow.entity_name') }}</label>
                    <base-tooltip-icon v-if="workflowList == null || workflowList.length === 0" size="sm" :content="tooltipWorkflow" class="ml-2"/>
                </div>
                <el-form-item prop="idFlujoAprobacion">
                  <el-select
                    v-model="form.idFlujoAprobacion"
                    filterable
                    clearable
                    :placeholder="$t('app.select')"
                    :disabled="isLoadingSelect"
                    class="w-full">
                    <el-option
                      v-for="item in workflowList"
                      :key="item.IdFlujoAprobacion"
                      :label="item.Nombre"
                      :value="item.IdFlujoAprobacion"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="mb-4" v-if="form.EnEmision">
              <div class="flex flex-row items-center">
                <el-switch class="switch-text break-normal" v-model="form.EnviarAutomaticamente" :active-text="$t('configurations.envia_auto')"></el-switch>
              </div>
            </div>

            <div class="mb-4">
              <div class="flex flex-row items-center mb-4 lg:mb-0">
                <el-switch class="switch-text break-normal" v-model="form.DetenerEjecucion" :active-text="$t('rules.detener_ejecucion')"></el-switch>
              </div>
            </div>

            <div class="mb-6">
              <div class="flex flex-row items-center mb-4 lg:mb-0">
                <el-switch class="switch-text break-normal" v-model="form.Activa" :active-text="$t('app.active')"></el-switch>
              </div>
            </div>

            <!-- Comentado temporalmente -->

            <!-- <div class="lg:mb-6">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('rules.estado_destino')}}</label>
              <el-form-item prop="estadoDestino" class="w-full mb-2">
                <el-select 
                  class="w-full" 
                  filterable 
                  clearable
                  v-model="form.estadoDestino"
                  :placeholder="$t('rules.estado_destino_placeholder')"
                  >
                  <el-option
                    v-for="item in tiposEstadosRule"
                    :key="item.id"
                    :label="item.Nombre"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div> -->

            <div class="lg:mb-2" v-if="form.EnEmision">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.cod_pge_salida')}}</label>
              <el-form-item prop="codigoPGESalida" class="w-full mb-2">
                <el-select 
                  class="w-full" 
                  filterable 
                  clearable
                  v-model="form.codigoPGESalida"
                  :placeholder="$t('rules.pge_placeholder')"
                  >
                  <el-option
                    v-for="item in tiposPGERule"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div v-if="(role !== 7 && role !== 8 && role !== 3) || form.clienteId">

              <div class="flex flex-row items-center">
                <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('rules.condiciones')}}</h3>
              </div>

              <div v-for="(condicion, key) in form.condiciones" :key="key"
                class="mb-2 mt-2 flex flex-col items-center w-full relative"
                >
                <div 
                  v-if="key > 0"
                  class="-top-5 absolute pl-2 pr-2 pt-1 pb-1 flex content-center justify-center dark:text-darkblue-200 bg-primary-50 dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border"
                >
                  {{$t('app.and').toUpperCase()}}
                </div>
                <base-button-icon
                  @click="removeCondiction(key)"
                  name="cross"
                  mode="primary-phantom"
                  class="-top-3 -right-3 absolute"
                  custom="dark:border dark:border-darkblue-600"
                />
                <div class="w-full p-4 bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border">
                  <div class="flex -mx-2 flex-col lg:flex-row">
                    <div class="px-2 w-full lg:mb-0">
                      <label class="text-sm font-semibold text-secondary-600 block mb-2">{{$t('rules.campo')}}</label>
                        <el-form-item :prop="'condiciones.'+ key + '.campo'"
                          :rules="generalRules.general"
                          >
                          <el-select 
                            class="w-full" 
                            filterable 
                            v-model="form.condiciones[key].campo" 
                            clearable
                            @change="onChangeMetadato(key)"
                            >

                            <el-option-group
                              v-for="group in dataMetadatosCondiciones"
                              :key="group.label"
                              :label="group.label">
                              <el-option
                                v-for="item in group.options"
                                :key="item.idMetadato"
                                :label="item.Descripcion"
                                :value="item.value"
                                :disabled="checkDisabledMetadata(item, group)"
                                >
                              </el-option>
                            </el-option-group>
                          </el-select>
                        </el-form-item>
                    </div>
                    <div class="px-2 w-full lg:mb-0">
                      <label class="text-sm font-semibold text-secondary-600 block mb-2">{{$t('rules.tipo_condicion')}}</label>
                      <el-form-item :prop="'condiciones.'+ key + '.tipoCondicion'"
                        :rules="generalRules.general"
                      >
                        <el-select 
                          class="w-full" 
                          filterable 
                          v-model="form.condiciones[key].tipoCondicion" 
                          clearable
                          @change="onChangeTipoCondicion(key)"
                        >
                          <el-option
                            v-for="condicion in getListaCondiciones(form.condiciones[key].campo)"
                            :key="condicion.idTipoCondicion"
                            :label="getTypeCondition(condicion.idTipoCondicion)"
                            :value="condicion.idTipoCondicion">
                          </el-option>
                          <!-- <el-option
                            v-for="condicion in getListaCondiciones(form.condiciones[key].campo)"
                            :key="condicion.idTipoCondicion"
                            :label="condicion.Descripcion"
                            :value="condicion.idTipoCondicion">
                          </el-option> -->
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="flex -mx-2 flex-col lg:flex-row">
                    <div class="px-2 w-full lg:mb-0">
                      <div class="flex items-center mb-1">
                        <div class="flex items-center">
                          <label class="text-sm font-semibold text-secondary-600 block">{{$t('rules.valor')}}</label>
                          <base-tooltip-icon 
                            v-if="(form.condiciones[key].tipoCondicion === 9 || form.condiciones[key].tipoCondicion === 10)" 
                            size="sm" 
                            :content="contentTooltipValorRegex" 
                            class="ml-2"/>
                        </div>
                      </div>

                      <div class="w-full">
                        <div v-for="(valor, keyValor) in condicion.valores" :key="keyValor"
                          class="relative flex w-full items-center justify-center"
                        >
                          <div 
                            v-if="keyValor > 0"
                            class="text-xs z-20 -top-5 absolute pl-1 pr-1 dark:text-darkblue-200 bg-primary-50 dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border"
                          >
                            {{$t('app.or').toUpperCase()}}
                          </div>
                            <div class="flex w-full">
                              <el-form-item :prop="'condiciones.'+ key + '.valores.' + keyValor"
                                :rules="generalRules.general"
                                class="w-full"
                                >

                                <el-input
                                  v-if="getTipoDato(form.condiciones[key].campo) === 1"
                                  class="w-full"
                                  v-model="form.condiciones[key].valores[keyValor]"
                                  clearable
                                  min="0"
                                  max="9999999999"
                                  type="number"
                                  :placeholder="$t('app.numeric_placeholder_long')"
                                />
                                
                                <el-date-picker
                                  v-else-if="getTipoDato(form.condiciones[key].campo) === 3"
                                  class="bg-white dark:bg-darkblue-900 full-width-important"
                                  v-model="form.condiciones[key].valores[keyValor]"
                                  :picker-options="dateRangeOptions"
                                  type="datetime"
                                  :format="datePattern"
                                  value-format="dd/MM/yyyy HH:mm:ss"
                                  :placeholder="$t('app.date_placeholder_long')">
                                </el-date-picker>

                                <el-select 
                                  v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                  (
                                    form.condiciones[key].campo === 'Forma de Pago' ||
                                    form.condiciones[key].campo === 'Forma de envío' || 
                                    form.condiciones[key].campo === 'Moneda de la operación' || 
                                    form.condiciones[key].campo === 'Clase de Impuesto' ||
                                    form.condiciones[key].campo === 'Clase de Retención'
                                  )"
                                  class="w-full" 
                                  v-model="form.condiciones[key].valores[keyValor]"
                                  value-key="id"
                                  clearable
                                  filterable
                                  :placeholder="$t('app.select_value_placeholder')"
                                  >
                                  <el-option
                                    v-for="(item, index) in getListaSelect(form.condiciones[key].campo)"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.id"
                                    >
                                  </el-option>
                                </el-select>

                                <el-select 
                                  v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                  (
                                    form.condiciones[key].campo === 'CIF Propietario'
                                  ) &&
                                  (
                                    form.condiciones[key].tipoCondicion === 1 ||
                                    form.condiciones[key].tipoCondicion === 2
                                  )"
                                  class="w-full" 
                                  v-model="form.condiciones[key].valores[keyValor]"
                                  value-key="id"
                                  clearable
                                  filterable
                                  allow-create
                                  maxlength='100'
                                  :placeholder="$t('app.select_cif_or_group_placeholder_long')"
                                  >
                                  
                                  <el-option-group
                                    v-for="group in getListaSelect(form.condiciones[key].campo, form.condiciones[key].tipoCondicion === 2)"
                                    :key="group.label"
                                    :label="group.label">
                                    <el-option
                                      v-for="(item, index) in group.options"
                                      value-key="id"
                                      :key="index"
                                      :label="item.label"
                                      :value="item"
                                    >
                                    </el-option>
                                  </el-option-group>
                                </el-select>

                                <el-select 
                                  v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                  (
                                    form.condiciones[key].campo === 'Cliente' ||
                                    form.condiciones[key].campo === 'Proveedor'
                                  ) &&
                                  (
                                    form.condiciones[key].tipoCondicion === 1 ||
                                    form.condiciones[key].tipoCondicion === 2
                                  )"
                                  class="w-full" 
                                  v-model="form.condiciones[key].valores[keyValor]"
                                  value-key="id"
                                  clearable
                                  filterable
                                  :placeholder="$t('app.select_entity_or_group_placeholder_long', { entity: form.condiciones[key].campo })"
                                >
                                  
                                  <el-option-group
                                    v-for="group in getListaSelect(form.condiciones[key].campo, form.condiciones[key].tipoCondicion === 2)"
                                    :key="group.label"
                                    :label="group.label">
                                    <el-option
                                      v-for="(item, index) in group.options"
                                      :key="index"
                                      :label="item.label"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-option-group>
                                </el-select>

                                <el-input
                                  v-else
                                  class="w-full"
                                  v-model="form.condiciones[key].valores[keyValor]"
                                  clearable
                                  maxlength='500'
                                  :placeholder="(form.condiciones[key].tipoCondicion === 9 || form.condiciones[key].tipoCondicion === 10) 
                                    ? $t('app.regex_plaholder_long')
                                    : $t('app.new_value_placeholder_long')"
                                />

                              </el-form-item>
                              <div class="w-10">
                                <base-button-icon
                                  v-if="form.condiciones[key].valores && form.condiciones[key].valores.length > 1"
                                  @click="removeValue(key, keyValor)"
                                  name="cross"
                                  mode="primary-phantom"
                                  size="xs"
                                  iconSize="xs"
                                  class="ml-2 mt-1"
                                  custom="dark:border dark:border-darkblue-600"
                                />
                              </div>
                            </div>
                          </div>

                        <!-- Sin "OR" en caso de que sea el tipo de condicion "Distinto de" -->
                        <div 
                          v-if="form.condiciones[key].tipoCondicion !== 2"
                          class="flex flex-row items-center mt-2">
                          <base-button-responsive
                            mode="primary-phantom"
                            :text="$t('rules.add_value')"
                            icon="plus"
                            @click="addValue(key)"
                            :loading="isGeneralLoading"
                            custom="dark:border dark:border-darkblue-600"
                          />
                        </div>
                      </div>

                      <div
                        v-if="(form.condiciones[key].tipoCondicion === 9)" 
                      >
                        <div class="flex items-center mt-4 mb-1">
                          <label class="text-sm font-semibold text-secondary-600 block">{{$t('rules.metadata_regex')}}</label>
                          <base-tooltip-icon 
                            size="sm" 
                            :content="contentTooltipMetadataRegex" 
                            class="ml-2"/>
                        </div>
                        <el-form-item :prop="'condiciones.'+ key + '.metadatoRegex'"
                          :rules="generalRules.general"
                          class="w-full"
                          >
                          <el-select
                            class="w-full"
                            v-model="form.condiciones[key].metadatoRegex"
                            clearable
                            filterable
                            allow-create
                            maxlength='100'
                            :placeholder="$t('app.select_entity_placeholder_long', { entity: $tc('invoices.metadatos.metadato', 1).toLowerCase() })">
                            <el-option
                              v-for="item in listMetadatasClient"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>

                          <!-- <el-input
                            class="w-full"
                            v-model="form.condiciones[key].metadatoRegex"
                            clearable
                            maxlength='100'
                          /> -->
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="flex flex-row items-center">
                <base-button-responsive
                  mode="primary-phantom"
                  :text="$t('rules.add_condition')"
                  icon="plus"
                  @click="addCondition()"
                  :loading="isGeneralLoading"
                />
              </div>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

import { getClients } from '@/services/clients/getClients'

import { getRule } from '@/services/configurations/rules/getRule'
import { newRule } from '@/services/configurations/rules/newRule'
import { updateRule } from '@/services/configurations/rules/updateRule'

import { getMetadatosCondiciones } from '@/services/configurations/rules/getMetadatosCondiciones'

import { getCifsAgrupaciones } from '@/services/configurations/rules/getCifsAgrupaciones'
import { getProveedoresAgrupaciones } from '@/services/configurations/rules/getProveedoresAgrupaciones'
import { getClientesAgrupaciones } from '@/services/configurations/rules/getClientesAgrupaciones'
import { getListMetadatas } from '@/services/clients/lists/getListMetadatas'
import { getAllWorkflows } from '@/services/configurations/workflow/getAllWorkflows'
import waitUntil from '@/services/functions/waitUntil'

function checkValidPrioridad (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 1 && value <= 1000) {
      return true
    }
  }
  return false
}

export default {
  /* eslint-disable camelcase */
  name: 'rule-detail',
  components: {
    DetailLayout,
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      searchView: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: i18n.t('rules.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/rules'
      },
      loadingSetRule: false,
      isLoadingSelect: false,
      firstLoad: true,
      tooltipPrioridad: i18n.t('tooltip.prioridad'),
      tooltipWorkflow: i18n.t('approval_workflow.tooltip_workflow'),
      linkWorkflow: false,
      workflowList: [],
      numMaxCondiciones: 10,
      numMaxValores: 10,
      dataMetadatosCondiciones: [],
      listMetadatasClient: [],
      listaCifs: [],
      listaClientes: [],
      listaProveedores: [],
      form: this.getDefaultForm(),
      clientes: [],
      contentTooltipValor: i18n.t('tooltip.multiple_rule_value_msg'),
      contentTooltipValorRegex: i18n.t('tooltip.regex_explanation_tooltip'),
      contentTooltipMetadataRegex: i18n.t('tooltip.regex_metadato_destino'),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      updateRules: {
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        idFlujoAprobacion: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        prioridad: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isPriorityValid, trigger: 'blur' }
        ],
      },
      newRules: {
        clienteId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        idFlujoAprobacion: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        prioridad: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isPriorityValid, trigger: 'blur' }
        ],
      },
      generalRules: {
        general: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
      }
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_datetime'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    tiposEstadosRule () {
      if (this.form.EnEmision) return this.tiposEstados
      else return this.tiposEstadosRecibidas
    },
    tiposPGERule () {
      if (this.form.EnEmision) return this.pgeTypes
      else return this.pgeTypesRecepcion
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isClientFilterActive () {
      return this.$store.getters['rules/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterVNav']
    },
    tiposEstados: function () {
      return this.$store.getters['config/TIPOS_ESTADO'].filter(x => x.Regla)
    },
    tiposEstadosRecibidas: function () {
      return this.$store.getters['config/TIPOS_ESTADO_RECEPCION'].filter(x => x.Regla)
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE']
    },
    pgeTypesRecepcion: function () {
      return this.$store.getters['config/TIPOS_PGE_RECEPCION']
    },
    formasDePago: function () {
      return this.$store.getters['config/FORMAS_DE_PAGO']
    },
    tiposCodigoImpuesto: function () {
      return this.$store.getters['config/TIPOS_CODIGO_IMPUESTO']
    },
    monedaOperacion: function () {
      return this.$store.getters['config/MONEDA_OPERACION']
    },
    tiposMetadatos: function () {
      return this.$store.getters['config/TIPOS_METADATOS']
    },
    tiposCondicion: function () {
      return this.$store.getters['config/TIPOS_CONDICION']
    }
  },
  watch: {
    'form.clienteId': function (value, oldValue) {
      this.onChangeClient()
    },
    'form.EnEmision': function (value, oldValue) {
      this.onChangeEnEmision()
    }, 
  },
  created: async function () {
    const breadcrumbs = []

    if (this.role === 7 || this.role === 8 || this.role === 3) {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: i18n.t('configurations.header')
      })
    }
    breadcrumbs.push({ path: 'configurations/rules', name: i18n.t('rules.distribution_rules') })

    
    // if (this.role !== 3) await this.initialiceSelects()

    if (!this.isCreate) {
      setTimeout(async () => {
        await this.downloadData(this.id)
        breadcrumbs.push({ path: '', name: this.form.name })
        this.$store.commit('app/setheaderBreadCrumb', this.form.name)
        await this.getWorkflowList()
      }, 100)
    } else {
      breadcrumbs.push({
        path: '',
        name: i18n.t('rules.new_rule')
      })
      this.addCondition()

      if (this.actualFilterNav && this.isClientFilterActive) {
        this.form.clienteId = this.actualFilterNav.idCliente 
      }
    }
    if (!this.isCreate || this.role === 2) await this.initialiceSelects()
    
    this.header.breadcrumb = breadcrumbs

    this.firstLoad = false
  },
  mounted () {
    // this.resetControlFormChanges()
  },
  methods: {
    getWorkflowList: async function () {
      this.isLoadingSelect = true
      try {
        const data = await getAllWorkflows()
        if (data.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        } else {
          this.workflowList = data.Flujos.filter(workflow => workflow.IdCliente === this.form.clienteId)
        }
      } catch (error) {
        this.doFeedback()
        console.error(error)
      } finally {
        this.isLoadingSelect = false
      }
    },
    getTypeCondition (idCondicion) {
      const type = this.tiposCondicion.find(x => x.id === idCondicion)
      if (type) return type.name
      console.warn(i18n.t('feedback.warning.unrecognize_condition_warn', { condition: idCondicion }))
      return idCondicion
    },
    checkDisabledMetadata (item, group) {
      if (group.label === 'Metadatos') {
        if (item.Descripcion === 'Proveedor') {
          if (this.form.EnEmision) {
            return true
          }
        }
        if (item.Descripcion === 'Cliente') {
          if (this.form.EnEmision === false) {
            return true
          }
        }
      }

      return false
    },
    onChangeClient: async function () {
      if (!this.firstLoad) {
        if (this.role === 7 || this.role === 8 || this.role === 3) {
        // Get datos estaticos
          this.initialiceSelects()
        }
      }
      await this.getWorkflowList()
    },
    onChangeEnEmision: async function () {
      if (!this.loadingSetRule) {
        await this.setMetadatosCondiciones()
        this.form.estadoDestino = null
        this.form.codigoPGESalida = null
      }
    },
    isPriorityValid: function (rule, value, callback) {
      if (!value) {
        callback(new Error(i18n.t('validation.complete')))
        // callback() // queremos que la validación sea opcional en este caso.
      } else if (!checkValidPrioridad(value)) {
        callback(new Error(i18n.t('validation.rules.priority')))
      } else {
        callback()
      }
    },
    onChangeMetadato (index) {
      this.form.condiciones[index].tipoCondicion = null
      this.form.condiciones[index].valores = ['']
    },
    onChangeTipoCondicion (index) {
      this.form.condiciones[index].valores = ['']
    },
    initialiceSelects: async function () {
      await this.setMetadatosCondiciones()
  
      this.listaCifs = []
      const respuestaCifs = await getCifsAgrupaciones(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.listaCifs.push({
        label: i18n.t('grouping.header'),
        options: respuestaCifs.Agrupaciones ? respuestaCifs.Agrupaciones.map(x => ({
          valor: x.id,
          label: x.valor,
          id: x.id,
          esAgrupacion: true,
        })) : []
      })
      this.listaCifs.push({
        label: i18n.t('companies.cif'),
        options: respuestaCifs.Entidades ? respuestaCifs.Entidades.map(x => ({
          valor: x.valor,
          label: x.valor,
          id: x.valor,
          esAgrupacion: false,
        })) : []
      })
      this.listaCifs.push({
        label: i18n.tc('app.values'),
        options: []
      })

      this.listaClientes = []
      const respuestaClientes = await getClientesAgrupaciones(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.listaClientes.push({
        label: i18n.t('grouping.header'),
        options: respuestaClientes.Agrupaciones ? respuestaClientes.Agrupaciones.map(x => ({
          valor: x.id,
          label: x.valor,
          id: x.id,
          esAgrupacion: true,
        })) : []
      })
      this.listaClientes.push({
        label: i18n.t('clients.header'),
        options: respuestaClientes.Entidades ? respuestaClientes.Entidades.map(x => ({
          valor: x.valor,
          label: x.valor,
          id: x.valor,
          esAgrupacion: false,
        })) : []
      })

      this.listaProveedores = []
      const respuestaProveedores = await getProveedoresAgrupaciones(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.listaProveedores.push({
        label: i18n.t('grouping.header'),
        options: respuestaProveedores.Agrupaciones ? respuestaProveedores.Agrupaciones.map(x => ({
          valor: x.id,
          label: x.valor,
          id: x.id,
          esAgrupacion: true,
        })) : []
      })
      this.listaProveedores.push({
        label: i18n.t('agenda.sellers'),
        options: respuestaProveedores.Entidades ? respuestaProveedores.Entidades.map(x => ({
          valor: x.valor,
          label: x.valor,
          id: x.valor,
          esAgrupacion: false,
        })) : []
      })

      const respuestaMetadataClient = await getListMetadatas(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.listMetadatasClient = respuestaMetadataClient.Respuesta ? respuestaMetadataClient.Respuesta.map(x => ({ value: x.Campo, label: x.Campo })) : []
    },
    setMetadatosCondiciones: async function () {
      try {
        await waitUntil(() => this.loadingSetMetadatosCondiciones === false, 500)
        this.loadingSetMetadatosCondiciones = true
        this.dataMetadatosCondiciones = []
        const params = { EnRecepcion: !this.form.EnEmision }
        if (this.role === 7 || this.role === 8 || this.role === 3) {
          params.idCliente = this.form.clienteId
        }
        const respuestaMetadatos = await getMetadatosCondiciones(params)
        const metadatos = {
          label: i18n.t('invoices.metadatos.metadato_plural_short'),
          options: []
        }
        respuestaMetadatos.Metadatos.forEach(x => {
          const metadato = this.tiposMetadatos.find(m => m.id === x.idMetadato)
          metadatos.options.push({ ...x, Descripcion: metadato?.name ?? x.Descripcion, value: metadato?.value ?? x.Descripcion })
        })
        this.dataMetadatosCondiciones.push(metadatos)
        if (respuestaMetadatos.MetadatosAdicionales !== null && respuestaMetadatos.MetadatosAdicionales !== undefined) {
          const metadatosAdicionales = {
            label: i18n.tc('invoices.metadatos.metadato', 2),
            options: []
          }
          respuestaMetadatos.MetadatosAdicionales.forEach(x => {
            const metadato = this.tiposMetadatos.find(m => m.id === x.idMetadato)
            metadatosAdicionales.options.push({ ...x, Descripcion: metadato?.name ?? x.Descripcion, value: metadato?.value ?? x.Descripcion })
          })
          this.dataMetadatosCondiciones.push(metadatosAdicionales)
        }
      } finally {
        this.loadingSetMetadatosCondiciones = false
      }
    },
    getListaCondiciones (metadatoValue) {
      return this.dataMetadatosCondiciones.flatMap(x => x.options).find(x => x.value === metadatoValue)?.TiposCondiciones ?? []
    },
    getTipoDato (metadatoValue) {
      return this.dataMetadatosCondiciones.flatMap(x => x.options).find(x => x.value === metadatoValue)?.idTipoDato ?? -1
    },
    getListaSelect (metadatoValue, esDistintoDe = false) {
      if (metadatoValue === 'Forma de Pago') {
        return this.formasDePago
      }
      if (metadatoValue === 'Forma de envío') {
        return this.pgeTypes
      }
      if (metadatoValue === 'Clase de Impuesto' || metadatoValue === 'Clase de Retención') {
        return this.tiposCodigoImpuesto
      }
      if (metadatoValue === 'Moneda de la operación') {
        return this.monedaOperacion
      }

      if (metadatoValue === 'CIF Propietario') {
        if (esDistintoDe) return this.listaCifs.filter(x => x.label !== i18n.t('grouping.header'))
        return this.listaCifs
      }
      if (metadatoValue === 'Cliente') {
        if (esDistintoDe) return this.listaClientes.filter(x => x.label !== i18n.t('grouping.header'))
        return this.listaClientes
      }
      if (metadatoValue === 'Proveedor') {
        if (esDistintoDe) return this.listaProveedores.filter(x => x.label !== i18n.t('grouping.header'))
        return this.listaProveedores
      }
      return []
    },
    addCondition () {
      if (this.form.condiciones.length >= this.numMaxCondiciones) {
        this.doFeedback(i18n.t('feedback.warning.max_rule_conditions_warn', { maxConditions: this.numMaxCondiciones }), 'warning')
        return
      }
      const newCondition = {
        campo: null,
        tipoCondicion: null,
        valores: [''],
      }
      this.form.condiciones.push(newCondition)
    },
    addValue (index) {
      if (this.form.condiciones[index].valores.length >= this.numMaxValores) {
        this.doFeedback(i18n.t('feedback.warning.max_rule_values_warn', { maxConditions: this.numMaxValores }), 'warning')
        return
      }
      this.form.condiciones[index].valores.push('')
    },
    removeCondiction (index) {
      if (this.form.condiciones) this.form.condiciones.splice((index), 1)
    },
    removeValue (index, indexValue) {
      if (this.form.condiciones && this.form.condiciones[index].valores) {
        this.form.condiciones[index].valores.splice(indexValue, 1)
      }
    },
    getDefaultForm: function () {
      return {
        id: 0,
        clienteId: null,
        idFlujoAprobacion: null,
        name: '',
        prioridad: 100,
        EnEmision: true,
        EnviarAutomaticamente: false,
        DetenerEjecucion: true,
        Activa: true,
        estadoDestino: null,
        codigoPGESalida: null,

        condiciones: [],

        EnUso: false,
      }
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newRuleHandler(formName)
      } else {
        this.updateRuleHandler(formName)
      }
    },
    newRuleHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // TODO Dependiendo del tipo de grupo
          const params = {
            idCliente: this.form.clienteId,
            Nombre: this.form.name,
            Prioridad: this.form.prioridad,
            EnEmision: this.form.EnEmision,
            EnviarAutomaticamente: this.form.EnEmision ? this.form.EnviarAutomaticamente: null,
            DetenerEjecucion: this.form.DetenerEjecucion,
            Activa: this.form.Activa,
            idEstadoSalida: this.form.estadoDestino,
            codigoPGESalida: this.form.EnEmision ? this.form.codigoPGESalida : null,
            Condiciones: this.formatCondicionesCreateUpdate(this.form.condiciones),
            idFlujoAprobacion: !this.form.EnEmision && this.linkWorkflow ? this.form.idFlujoAprobacion : null
          }
          const response = await newRule(params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            // this.resetControlFormChanges()
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    formatCondicionesCreateUpdate (condiciones) {
      const result = JSON.parse(JSON.stringify(condiciones))
      // const result = condiciones.slice()
      result.forEach(x => {
        x.valores.forEach((y, index) => {
          if (typeof y !== 'object' &&
            !Array.isArray(y) &&
            y !== null) {
            x.valores[index] = {
              esAgrupacion: false,
              valor: y,
            }
          }
        })
      })
      return result
    },
    formatCondicionesGet (condiciones) {
      // Object => JSON => object
      const result = JSON.parse(JSON.stringify(condiciones))
      // Formateamos valores
      result.forEach(x => {
        x.valores.forEach((y, index) => {
          if (typeof y === 'object' &&
            // !Array.isArray(y) &&
            y !== null) {
            // Para condiciones de selección en los que tenemos valores previamente cargados
            if ((x.campo === 'CIF Propietario' || x.campo === 'Cliente' || x.campo === 'Proveedor') &&
              (x.tipoCondicion === 1 || x.tipoCondicion === 2)) {
              x.valores[index] = {
                esAgrupacion: y.esAgrupacion,
                valor: y.valor,
                id: y.valor,
              }
              if ((x.campo === 'CIF Propietario' || x.campo === 'Cliente' || x.campo === 'Proveedor') && !y.esAgrupacion) {
                if (this.listaCifs.length > 0 && !this.listaCifs[1].options.some(x => x.valor === y.valor)) {
                  this.listaCifs[2].options.push(
                    {
                      valor: y.valor,
                      label: y.valor,
                      id: y.valor,
                      esAgrupacion: false,
                    }
                  )
                }
              }
            } else {
              // Resto de casos (string, number, fecha) solo necesitamos valor
              x.valores[index] = y.valor
            }
          }
        })
      })
      return result
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateRuleHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // TODO Dependiendo del tipo de grupo
          const params = {
            idRegla: this.form.id,
            Nombre: this.form.name,
            Prioridad: this.form.prioridad,
            EnEmision: this.form.EnEmision,
            EnviarAutomaticamente: this.form.EnEmision ? this.form.EnviarAutomaticamente: null,
            DetenerEjecucion: this.form.DetenerEjecucion,
            Activa: this.form.Activa,
            idEstadoSalida: this.form.estadoDestino,
            codigoPGESalida: this.form.EnEmision ? this.form.codigoPGESalida : null,
            Condiciones: this.formatCondicionesCreateUpdate(this.form.condiciones),
            idFlujoAprobacion: !this.form.EnEmision && this.linkWorkflow ? this.form.idFlujoAprobacion : null
          }
          const response = await updateRule(params)
          if (response.blnError === false) {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.updateView()
            this.$store.commit('setAjaxRequestPending', false)
            // this.resetControlFormChanges()
          } else {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/rules' })
    },
    downloadData: async function (id) {
      let regla = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idRegla: id
        }
        regla = await getRule(params)
        this.setRule(regla.Respuesta)
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return regla
    },
    setRule: function (regla) {
      this.loadingSetRule = true
      this.form.id = regla.idRegla || '' 
      this.form.clienteId = regla.idCliente || ''
      this.form.name = regla.Nombre || ''
      this.form.prioridad = regla.Prioridad || ''
      this.form.EnEmision = !!regla.EnEmision
      this.form.EnviarAutomaticamente = !!regla.EnviarAutomaticamente
      this.form.DetenerEjecucion = !!regla.DetenerEjecucion
      this.form.Activa = !!regla.Activa
      this.form.estadoDestino = regla.idEstadoSalida || ''
      this.form.codigoPGESalida = regla.codigoPGESalida || ''
      this.form.condiciones = regla.Condiciones ? this.formatCondicionesGet(regla.Condiciones) : []
      this.form.enUso = !!regla.EnUso
      this.linkWorkflow = !!regla.idFlujoAprobacion
      this.form.idFlujoAprobacion = regla.idFlujoAprobacion || ''
      // this.resetControlFormChanges()
      this.loadingSetRule = false
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    },
  }
}
</script>
